module.exports = __webpack_public_path__ + "static/Diana-Pulido-ebfcd99f37785de707a57615137c6794.png";